import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import Wave from '../img/wave.png';

import LinkedIn from '@iconscout/react-unicons/icons/uil-linkedin';
import Github from '@iconscout/react-unicons/icons/uil-github';
import StackoverFooter from '../img/stackoverFooter.png';

export default function Footer() {
  const currentYear = new Date().getFullYear(); // Fetch the current year
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Define breakpoint for small screens

  return (
    <Box sx={{ position: 'relative', mt: -7, mx: { xs: 0, md: '-3.5rem' }, mb: isSmallScreen ? -100 : -18, pb: isSmallScreen && -100 }}>
      <img src={Wave} alt="" style={{ width: '100%' }} />
      <Box sx={{
        position: 'absolute',
        top: '9rem',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: '2rem', md: '5rem' },
        color: 'white',
        transform: { xs: 'scale(0.8)', md: 'scale(1)' },
        textAlign: 'center'
      }}>
        <Typography variant="body2" sx={{fontWeight: 'bold', fontSize: { xs: 18, md: 25 }, mt:isSmallScreen ? -16 : 20}}>
          ©{currentYear} Lakshay Rohilla
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: { xs: '1rem', md: '4rem' }, justifyContent: 'center', mt:isSmallScreen ? -4 : 0 }}>
          <a href='https://github.com/LakshayRohilla' target='_blank' rel="noreferrer">
            <Github color='white' size={isSmallScreen ? '2rem' : '3rem'} />
          </a>
          <a href="https://www.linkedin.com/in/lakshay-rohilla-02a23a119/" target='_blank' rel="noreferrer">
            <LinkedIn color='white' size={isSmallScreen ? '2rem' : '3rem'} />
          </a>
          <a href="https://stackoverflow.com/users/16876542/lakshay-rohilla" target='_blank' rel="noreferrer">
            <img src={StackoverFooter} alt="Stack Overflow" style={{ width: isSmallScreen ? '2rem' : '3rem' }} />
          </a>
        </Box>
      </Box>
    </Box>
  );
}